import 'url-search-params-polyfill';


export default {
    async sendEvent(eventType, eventData) {
      return fbq('track', eventType, eventData);
    },

    generateFbEid() {
        var fbEid = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (var i = 0; i < 32; i++) {
            fbEid += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return fbEid.toLowerCase();
    },

    grabFbClid() {
        console.log('grab fbclid');
        const urlParams = new URLSearchParams(window.location.search);
        var fbClid;
        if (urlParams !== null && urlParams.has('fbclid')) {
            fbClid = urlParams.get('fbclid');
        }

        return fbClid;
    }
};
